import React from "react";
import { Box, SelectChangeEvent } from "@mui/material";

import { CUSTOMERS_FILTERS, INPUT_TYPES } from "../../constants";

import { PRIMARY_LANGUAGE_OPTIONS } from "../../../FundedTraders/utils";
import Select from "../../../../components/ui/Select";
import FilterAutocomplete from "../../../../components/ui/FilterAutocomplete";
import { useSearchCustomersContext } from "../../../../context";

interface IProps {
  keyVal: number;
}
const CustomersFilters: React.FC<IProps> = ({ keyVal }) => {
  const { search, setSearch } = useSearchCustomersContext();
  const handleChangeRegion = (event: SelectChangeEvent<string>) => {
    setSearch({ ...search, primaryLanguage: event.target.value as string });
  };

  return (
    <Box display="flex" mt="15px" mb="15px">
      <FilterAutocomplete
        clearValuesFilter={keyVal}
        search={search}
        setSearch={setSearch}
        filters={CUSTOMERS_FILTERS}
        inputTypes={INPUT_TYPES}
        defaultSearchFields={{ Name: "name", Email: "email" }}
        deferSearch
      />
      <Box m="0 5px 10px 5px" width="320px">
        <Select
          fullWidth
          inputLabel="Primary language"
          label="Primary language"
          value={search.primaryLanguage}
          onChange={handleChangeRegion}
          options={PRIMARY_LANGUAGE_OPTIONS}
        />
      </Box>
    </Box>
  );
};

export default CustomersFilters;
